import React, { useState, useReducer, useEffect, useRef } from "react";
import { Button, Grid, Modal, Icon, Popup } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import { columnDefs, defaultColDef } from "./GridParamsColumn1/GridParams";
// import {
//   columnDefs_Ordo_Examen_Comp,
//   defaultColDef_Ordo_Examen_Comp,
// } from "./GridParam_Ordo_Examen_Comp/GridParams";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faVial } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

import { toast } from "react-toastify";

import { Editor } from "@tinymce/tinymce-react";
import he from "he";
import { selectisAuthenticated } from "../../../features/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { selectCounters, ExamenCompl_Counter_Reducer } from "../../../features/counter/counterSlice";


function Note(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const Auth = useSelector(selectisAuthenticated);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { ID, syncData, option, userInformation, AuthState } = props;
  let date_Lisible = moment().format("DD/MM/YYYY");
  const [SelectedCategorie, setSelectedCategorie] = useState(
    `<h4 style="text-align: center;">${date_Lisible ? date_Lisible : ".../.../......"
    }</h4>
        <h4 style="text-align: center;">${userInformation.civilite} ${userInformation.nom
    }
        ${userInformation.prenom}</h4>`
  );
  // const [SelectedCategorieText, setSelectedCategorieText] = useState('Acte Proposé');
  // ag grid state
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  const editorRef = useRef(null);

  // this function gets all types of (examens complementaire)  at once from database
  async function getOneUser() {
    await axios
      .get(`${server}Btn_First_Column/${option}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch({
          type: "FETCH_SUCCESS",
          payload: response.data,
          title: response.data[0].Nom_CategoryBtn,
        });
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }


  let appHtml = SelectedCategorie;
  const regex = new RegExp(`<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>`, "g");
  let result = [],
    matches;
  while (matches = regex.exec(appHtml)) {
    result.push(matches[1]);
  }

  let result2 = result.join(" , ").toString();

  let stripedHtml = result2.replace(/<[^>]+>/g, "");

  let decodedStripedHtml = he.decode(stripedHtml);

  const onValueChanged = async () => {
    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: state.og,
      od: decodedStripedHtml,
      fk_id_examen: 14,
      observation: state.observation,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
        toast.success("Success", {
          position: toast.POSITION.TOP_LEFT,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  async function AddToHistory() {
    // console.log(state);
    if (editorRef.current) {
      const ValuesToCreate = {
        nom_Examens_Compl: editorRef.current.getContent(),
        fk_id_patientConsul: ID,
      };
      axios({
        method: "post",
        responseType: "json",
        url: `${server}Consultation/ExamenCompl`,
        data: ValuesToCreate,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then((response) => {
          // GetAllExamenCompl();
          dispatchRedux(ExamenCompl_Counter_Reducer(CountersState.ExamenCompl_Counter + 1));
          onValueChanged();
          dispatch({ type: ACTION.CLOSE });
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  }

  useEffect(() => {
    getOneUser();
    // GetAllExamenCompl();
  }, [state.open]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_examen: "",
        Nom_CategoryBtn: "",
        Nom_Detail_1: "",
        fk_id_categoryBtn: "",
        id_detail_1: "",
      };
      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: emptyCheckbox,
      });
    } else if (e.api.getSelectedRows().length === 1) {
      const emptyCheckbox = e.api.getSelectedRows()[0];
      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: emptyCheckbox,
      });
      let clientArray = e.api.getSelectedRows();
      dispatch({
        type: ACTION.COURRIER_CONSUL,
        value: clientArray,
      });
    } else {
      const emptyCheckbox = {
        id_examen: "",
        Nom_CategoryBtn: "",
        Nom_Detail_1: "",
        fk_id_categoryBtn: "",
        id_detail_1: "",
      };
      dispatch({
        type: ACTION.LOAD_FIRST_TABLE,
        value: emptyCheckbox,
      });

      let clientArray = e.api.getSelectedRows();

      dispatch({
        type: ACTION.COURRIER_CONSUL,
        value: clientArray,
      });
    }
  };

  // const onSelectionChanged2 = (e) => {
  //   if (e.api.getSelectedRows()[0] === undefined) {
  //     const emptyCheckbox = {
  //       idExamens_Compl: "",
  //       nom_Examens_Compl: "",
  //       fk_id_patient_examen_compl: "",
  //       date_exam_compl: "",
  //       date_exam_compl_converted: "",
  //     };
  //     dispatch({
  //       type: ACTION.LOAD_History_examen_compl,
  //       value: emptyCheckbox,
  //     });
  //   } else {
  //     let clientArray = e.api.getSelectedRows()[0];
  //     let dateModificationExamenCompl = moment(
  //       clientArray.date_exam_compl
  //     ).format("YYYY-MM-DD");
  //     setDateExam(dateModificationExamenCompl);

  //     dispatch({
  //       type: ACTION.LOAD_History_examen_compl,
  //       value: clientArray,
  //     });
  //   }
  // };

  const onCellValueChanged = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Btn_First_Column`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.LOAD_FIRST_TABLE,
          value: data,
        });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  // const onCellValueChanged2 = async ({ data }) => {
  //   axios({
  //     method: "put",
  //     responseType: "json",
  //     url: `${server}Consultation/ExamenCompl`,
  //     data: data,
  //     headers: {
  //       jwtoken: sessionStorage.token,
  //     },
  //   })
  //     .then((response) => {
  //       dispatch({
  //         type: ACTION.FETCH_SUCCESS2,
  //         payload: response.data,
  //       });
  //       // GetAllExamenCompl();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       dispatch({ type: ACTION.CREATE_ERROR });
  //     });
  // };
  // const ModTimeExam = async (time) => {
  //   const dataToupdate = {
  //     idExamens_Compl: state.idExamens_Compl,
  //     nom_Examens_Compl: state.nom_Examens_Compl,
  //     fk_id_patient_examen_compl: state.fk_id_patient_examen_compl,
  //     date_exam_compl: time,
  //   };

  //   axios({
  //     method: "put",
  //     responseType: "json",
  //     url: `${server}Consultation/ExamenCompl`,
  //     data: dataToupdate,
  //     headers: {
  //       jwtoken: sessionStorage.token,
  //     },
  //   })
  //     .then((response) => {
  //       dispatch({
  //         type: ACTION.FETCH_SUCCESS2,
  //         payload: response.data,
  //       });
  //       // GetAllExamenCompl();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       dispatch({ type: ACTION.CREATE_ERROR });
  //     });
  // };

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Btn_First_Column/${state.fk_id_categoryBtn}/${state.id_detail_1}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatch({ type: ACTION.DELETE_SUCCESS });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  // const handleRemoveItem12 = async () => {
  //   axios({
  //     method: "DELETE",
  //     responseType: "json",
  //     url: `${server}Consultation/ExamenCompl/${state.idExamens_Compl}/${state.fk_id_patient_examen_compl}/ExamenCompl`,
  //     headers: {
  //       jwtoken: sessionStorage.token,
  //     },
  //   })
  //     .then(() => {
  //       dispatch({ type: ACTION.DELETE_SUCCESS });
  //       // GetAllExamenCompl();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       dispatch({ type: ACTION.CREATE_ERROR });
  //     });
  // };

  useEffect(() => {
    let dataToSeeFinal = "";
    dataToSeeFinal = state?.Courrier_Consul_Rows?.map(
      (item, i) => `<p style="font-size:14px">${item.Nom_Detail_1}</p>`
    );

    if (editorRef.current) {
      setSelectedCategorie(editorRef.current.getContent() + dataToSeeFinal);
    }
  }, [state.Courrier_Consul_Rows]);

  if (SelectedCategorie === "undefined") {
    setSelectedCategorie(
      `<h4 style="text-align: center;">${date_Lisible ? date_Lisible : ".../.../......"
      }</h4>
            <h4 style="text-align: center;">${userInformation.civilite} ${userInformation.nom
      }
            ${userInformation.prenom}</h4>`
    );
  }
  // console.log(SelectedCategorie);
  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={SelectedCategorie}
        init={{
          // selector: "textarea",
          branding: false,
          height: "81.5vh",
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
          ],
          toolbar:
            "undo redo |" + "bold italic underline forecolor backcolor print",
          content_style:
            "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm;} body{font-size:16px} ",
        }}
      />
    </div>
  );

  let supprimerDefinitivement

  if (Auth.role === "admin" && state.id_detail_1) {
    supprimerDefinitivement = <Button
      negative
      onClick={handleRemoveItem1}
      floated="right"
      icon
    >
      Supprimer définitivement
    </Button>
  } else {
    supprimerDefinitivement = <Button disabled negative floated="right" icon>
      Supprimer définitivement
    </Button >
  }



  return (
    <>
      {/* diagn */}
      <Popup
        content="Examen complémentaire"
        trigger={
          <Button
            color="teal"
            // Icon
            onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
          >
            <Icon name="lab" size='large' className="centerIcon" />
            {/* <FontAwesomeIcon
              className="FixHeightFontAwsome"
              icon={faVial}
              size="lg"
            />{" "} */}
          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => {
          dispatch({ type: ACTION.CLOSE });
        }}
        className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          Examens complémentaires
          {/* <Button
            floated="left"
            color="blue"
            onClick={() => {
              dispatch({ type: ACTION.CLOSE });
            }}
          >
            Retour
          </Button> */}
          <Button
            floated="right"
            color="blue"
            onClick={() => dispatch({ type: ACTION.CLOSE })}
          >
            Retour <Icon className="leftSpace" name="reply" />
          </Button>
          <Button floated="right" positive onClick={() => AddToHistory()}>
            Sauvegarder et retour
          </Button>
          {/* <input
            // key={999}
            style={styles.datePickerCustom}
            type="date"
            defaultValue={dateExam}
            onChange={(e) => ModTimeExam(e.target.value)}
          /> */}
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={10}>{Contents}</Grid.Column>
            <Grid.Column width={6}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowSelection={"multiple"}
                  rowData={state.rowData ? state.rowData : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  // rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged}
                ></AgGridReact>
              </div>
              <br />
              {supprimerDefinitivement}
            </Grid.Column>
            {/* <Grid.Column width={6}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs_Ordo_Examen_Comp}
                  defaultColDef={defaultColDef_Ordo_Examen_Comp}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged2}
                ></AgGridReact>
              </div>
              <br />
              <Button
                negative
                onClick={handleRemoveItem12}
                floated="right"
                icon
              >
                <Icon name="delete" />
              </Button>
            </Grid.Column> */}
          </Grid>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Note;
